import { RegisterProps } from "./RegisterProps"
import "./Register.scss";
import ResetPasswordPopup from "../../content/Profile/ResetPasswordPopup/ResetPasswordPopup";
import { useCallback, useEffect, useState } from "react";
import usersService from "../../../Axios/services/users.service";
import { useSearchParams } from 'react-router-dom'

export const ResetPassword = (props: RegisterProps) => {

    const [user, setUser] = useState(null)
    const [mounted, setMounted] = useState(true)

    const pullUser = useCallback(async () => {
        try {

            const windowUrl = window.location.search;
            const params = new URLSearchParams(windowUrl);
            let uid = params.get('uid');
            let email = params.get('email')

            if (uid && email) {
                const user = await usersService.resetUserById(uid, email);
                if (user && mounted)
                    setUser(user)
            }
        } catch (err) {
            console.error(err)
        }
    }, [props.location.search, mounted])


    useEffect(() => {
        pullUser()
        return () => {
            setMounted(false)
        }
    }, [pullUser])


    return (
        <div className="register-screen">
            <div className="triangle"></div>
            <div className="main-title"></div>
            <div className="form-wrapper d-flex justify-content-center">
                <ResetPasswordPopup history={props.history} pulledUser={user} isNew={true} />
            </div>
        </div>
    )
}